export default [
    {
        name: "startProviderCreditLimitChangeFlow",
        path: "/providers/:providerKey/credit_limit_change/start",
        component: () => import("@/views/account/CreditLimitChangeAmountCollectionView"),
        meta: {
            stepper: false,
        },
    },
    {
        name: "providerCreditLimitChangeIncomeCollection",
        path: "/providers/:providerKey/credit_limit_change/income",
        component: () => import("@/views/account/CreditLimitChangeIncomeCollectionView"),
        meta: {
            stepper: false,
        },
    },
    {
        name: "providerCreditLimitChangeResult",
        path: "/providers/:providerKey/credit_limit_change/result",
        component: () => import("@/views/account/CreditLimitChangeResultView"),
        meta: {
            stepper: false,
        },
    },
]
